import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { MatSelectComponent, MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from './select.component';
import { MatSelectTriggerDirective } from './select-trigger.directive';
import { FormFieldModule } from '../form-field';
import { OptionModule } from '../option';

@NgModule({
  imports: [CommonModule, OverlayModule, OptionModule, MatCommonModule],
  exports: [
    CdkScrollableModule,
    FormFieldModule,
    MatSelectComponent,
    MatSelectTriggerDirective,
    OptionModule,
    MatCommonModule,
  ],
  declarations: [MatSelectComponent, MatSelectTriggerDirective],
  providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER],
})
export class SelectModule {}
